import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrManager } from 'ng6-toastr-notifications';

import { CucurachaAdminService } from '../service/cucuracha.service';
import { ExcelService } from '../service/tableUtility.service';

@Component({
  selector: 'app-vendorproductmanagement',
  templateUrl: './vendorproductmanagement.component.html',
  styleUrls: ['./vendorproductmanagement.component.css']
})
export class VendorproductmanagementComponent implements OnInit {
  searchValue:any;
  filterValueSelected:any;
  showCustomisedSearch:boolean=false
  showFilter: boolean = false
  read: any;
  write: any;
  delete: any;
  export:any
  show: boolean = false
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns = ['accountDetails.vendorName',  'accountEmailId', 'productName','productImage', 'description', 'keyWords', 'stockQuantity', 'stockUnit', 'actualPrice','offeredPrice', 'expiryDate', 'category','subCategory']
  dataSource: any;
  userDetails: any;
  tableData: any;
  productImageId: any;
  myurl: string;
  constructor(private cs: CucurachaAdminService, private excelService: ExcelService, private toastr: ToastrManager) {
    this.myurl = this.cs.endpoint;

   }

  ngOnInit(): void {
    this.getAllVendorproducts()
  }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }
  viewImages(id:any){
    this.productImageId=id
  }
  filter() {
    this.getAllVendorproducts()
    if (this.showFilter == false) {
      this.showFilter = true
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""
    }
    else {
      this.showFilter = false
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""
    }
  }
  applyCustomizedFilter() {
    this.showCustomisedSearch = true
    this.searchValue=""
    this.getAllVendorproducts();
  }
  applyCustomizedFilterSearch(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue;
    if (filterValue != "") {
      this.cs.customizedFilterForVendorsAccountProducts(this.filterValueSelected, filterValue).subscribe((data) => {
        console.log(data)
        this.dataSource = new MatTableDataSource(data.result)
      })
    }
    else {
      this.getAllVendorproducts()
    }
  }
  exportTable() {
    // TableUtil.exportToExcel("Example table",'usersManagement.xlsx');
    this.tableData = (this.dataSource.filteredData)
    console.log(this.tableData)
    this.excelService.exportAsExcelFile(this.tableData, 'VendorproductManagement');
    this.cs.exportLogAdd(this.userDetails.emailId, 'VendorproductManagement').subscribe((data) => {
    })
  }
  getAllVendorproducts() {
    this.cs.getVendorProducts().subscribe((data) => {
      this.dataSource = new MatTableDataSource(data.result)
      console.log(data.result)
      this.dataSource.sort = this.sort
      this.dataSource.paginator = this.paginator
    })
}
}
